var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title !== '메시지')?_c('a',{attrs:{"id":"sns-icon__wraps"},on:{"click":_vm.shareSns}},[_c('img',{attrs:{"src":_vm.image,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])]):_c('a',{attrs:{"id":"sns-icon__wraps","href":_vm.smsHref}},[_c('img',{attrs:{"src":_vm.image,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }